var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMemberPaysSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h17v17H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.889 2.833)",
    fill: "#7A8E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.346 0c1.564 0 2.832 1.243 2.832 2.776 0 1.534-1.268 2.777-2.832 2.777-.364 0-.712-.068-1.031-.19 1.054-.404 1.801-1.41 1.801-2.587 0-1.176-.747-2.182-1.8-2.586.318-.123.666-.19 1.03-.19z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.254,
    cy: 2.776,
    rx: 2.831,
    ry: 2.776
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.298 6.347h2.061c1.793 0 3.241 1.42 3.241 3.186v1.974c0 .216-.18.393-.401.393h-2.062a.398.398 0 0 0 .401-.393V9.533c0-1.766-1.448-3.186-3.24-3.186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.267 6.347H3.249C1.457 6.347 0 7.776 0 9.533v1.974c0 .216.18.393.401.393h9.705a.398.398 0 0 0 .401-.393V9.533c0-1.766-1.448-3.186-3.24-3.186z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMemberPaysSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-member-pays-small.ce69e21dffb8b42d4c6defa03473565d.svg";